import React, { useEffect } from 'react';
import images from '../../../themes/appImage';
import { useDispatch, useSelector } from 'react-redux';
import { getPostListLoad } from '../../../redux/slices/user.slice';
import CommunityPost from './CommunityPost';
import Loader from '../../global-components/loader';
import NoDataFound from '../../global-components/no-data-found';
import LoadMore from '../../global-components/load-more';
import { imageURL } from '../../../redux/Api/apikit';

const CommunityPosts = ({ listPayload, setListPayload, listDone, setListDone, localPostList, setLocalPostList }) => {

  const dispatch = useDispatch();
  const { postListData, loading, error } = useSelector(state => state.userReducer);
  const { removePostPass, removePostId, isPostLikeSuccess } = useSelector(state => state.CommunityReducer);

  useEffect(() => {
    dispatch(getPostListLoad(listPayload));
  }, [dispatch]);

  useEffect(() => {
    if (removePostPass) {
      const cloneLocalPostList = [...localPostList].filter(item => item._id !== removePostId.id)
      setLocalPostList(cloneLocalPostList)
    }
  }, [removePostPass]);

  useEffect(() => {
    if (postListData?.length < listPayload.limit && localPostList?.length > listPayload.limit) {
      setListDone(true)
    }
    setLocalPostList(pre => [...pre, ...postListData])
  }, [postListData])

  const loadMoreHandler = () => {
    const { offset, limit } = listPayload
    dispatch(getPostListLoad({ offset: offset + limit, limit: limit }));
    setListPayload(pre => ({ ...pre, offset: offset + limit }))
  }

  return (
    <div>
      {/*  */}
      {loading && !localPostList?.length > 0 ? (
        <div className='mt-3'>
          <Loader />
        </div>
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        <>
          <div className='flex flex-col gap-4 mt-4'>
            {localPostList && localPostList.length > 0 ? (
              localPostList.map(({ text, file, postType, createdAt, createdByMe, happyFace, partyFace, creatorData, redHeart, smileyFace, smileyHeart, comment, _id }) => (
                <CommunityPost
                  key={_id}
                  avatarSrc={createdByMe ? (images.matleFitLogo) : (creatorData?.avatar ? `${imageURL}${creatorData?.avatar}` : images.userProf)}
                  username={createdByMe ? "mentalfit" : creatorData?.userName}
                  time={createdAt}
                  description={text}
                  file={file}
                  postType={postType}
                  coverSrc={images.cardCover}
                  commentSrc={images.commentImg}
                  hugSrc={images.hug}
                  happyFace={happyFace}
                  partyFace={partyFace}
                  redHeart={redHeart}
                  smileyFace={smileyFace}
                  smileyHeart={smileyHeart}
                  comment={comment}
                  id={_id}
                />
              ))
            ) : (
              <NoDataFound />
            )}
          </div>
          <div className='flex justify-center mt-2'>
            {postListData?.length >= listPayload.limit && (
              <LoadMore loader={loading} onClick={loadMoreHandler} />
            )}
          </div>
        </>
      )}

    </div>
  );
}

export default React.memo(CommunityPosts);
